module.exports = __webpack_public_path__ + "static/img/loginTopBg.2afcc1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/loginTopBg.png
// module id = jR81
// module chunks = 2